// ABOUTME: Actuator for APOLLO-DRIVEN polling: hands the interval to a query's own startPolling and
// ABOUTME: stops it while the tab is hidden. For a function on an interval, use useVisibleInterval.
import { useWhileVisible } from "./useWhileVisible"

interface UseVisibilityPollingProps {
  startPolling: (interval: number) => void
  stopPolling: () => void
  pollInterval?: number
  enabled?: boolean
}

/**
 * Apollo owns the timer and the request: it skips a tick while one of the
 * query's requests is already in flight, and delivers errors to the hook the
 * way the query's own errorPolicy says. The lifecycle around it — and why the
 * tab coming back does not refetch at once — is useWhileVisible.
 */
export function useVisibilityPolling({
  startPolling,
  stopPolling,
  pollInterval = 5 * 60 * 1000, // Default 5 minutes
  enabled = true,
}: UseVisibilityPollingProps) {
  useWhileVisible({
    enabled,
    restartOn: pollInterval,
    start: () => startPolling(pollInterval),
    stop: stopPolling,
  })
}
